import { useDispatch, useSelector } from 'react-redux';
import {
  isLoginSelector,
  loginSucceeded,
  userIdAndTokenSelector,
  userSelector
} from '../redux/features/user/usersSlice';
import { jobListSelector } from '../redux/features/job/jobsSlice';
import { getLocalStorageAuthentication } from '../lib/auth';
import { useEffect } from 'react';

export const useCurrentUserInfo = () => {
  const dispatch = useDispatch();
  const isLogin = useSelector(isLoginSelector);
  const { userId, token } = useSelector(userIdAndTokenSelector);
  const userJobs = useSelector(jobListSelector);
  const user = useSelector(userSelector);
  const userHasAnyJob = userJobs && userJobs.length > 0;
  const isValidUser = userId && token;
  useEffect(() => {
    if (isValidUser && !isLogin) {
      // Get full user data from localStorage including fullName, email, and roles
      const localAuth = getLocalStorageAuthentication();
      if (localAuth) {
        console.log('🔄 [useCurrentUserInfo] Rehydrating session with roles:', localAuth.roles);
        dispatch(
          loginSucceeded({ 
            token, 
            user: { 
              userId: localAuth.userId,
              fullName: localAuth.fullName,
              email: localAuth.email,
              roles: localAuth.roles // Preserve roles from JWT token
            } 
          })
        );
      }
    }
  }, [isValidUser, isLogin, dispatch, token, userId]);
  return {
    isLogin,
    userId,
    token,
    userJobs,
    userHasAnyJob,
    isValidUser,
    user
  };
};
